import { Box, Flex, Image, Stack, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

import {
    useGetDevelopmentSelection2dQuery,
    useGetDevelopmentVisionByIdMutation,
} from "@/hooks/microservicesApi";

const GeneratePdfSelection2D = () => {
    const router = useRouter();
    const code = router.query.code;
    const view = router.query.view;
    const tower = router.query.tower;
    const { data } = useGetDevelopmentSelection2dQuery(code);
    const [getDataDevelopment] = useGetDevelopmentVisionByIdMutation();
    const [dataDevelopment, setDataDevelopment] = useState();
    const [viewSelected, setViewSelected] = useState([]);

    //Obtener la info del desarrollo
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getDataDevelopment(code).unwrap();
                setDataDevelopment(res[0]);
            } catch (error) {
                console.error("Error al obtener info del desarrollo", error);
            }
        };

        if (code) {
            fetchData();
        }
    }, [code]);

    //Seleccionar la vista y torre (si aplica) a mostrar
    useEffect(() => {
        if (data && dataDevelopment) {
            let selected;

            if (dataDevelopment?.condos?.length > 1 && tower) {
                // Si hay múltiples condos y se especificó torre, filtramos por ambos
                selected = data.find(
                    (vista) =>
                        vista.item_name.toLowerCase() === decodeURIComponent(view) &&
                        vista.outter_dimension_props[0]?.item_name?.toLowerCase() ===
                            decodeURIComponent(tower)
                );
            } else {
                // Si hay un solo condo o no se especificó torre, filtramos solo por vista
                selected = data.find(
                    (vista) => vista.item_name.toLowerCase() === decodeURIComponent(view)
                );
            }

            if (selected) setViewSelected(selected);
        }
    }, [data, dataDevelopment, view, tower]);

    // ===== VALIDATE AFTER LOAD COMPONENT - STATUS OF PROPERTIES TO SET COLOR GREEN, RED OR YELLOW =====
    const loadSvg = () => {
        const svg = document.getElementById("svg");
        if (svg) {
            // ==== VALIDATE TO IDENTIFY TYPE OF TAG ON IMAGE SVG ====
            let elementTagName = null;
            const rect = Array.from(svg.getElementsByTagName("rect"));
            const path = Array.from(svg.getElementsByTagName("path"));
            path.forEach((paths) => {
                paths.style.cursor = "pointer";
            });
            elementTagName = rect.concat(path);
            // ==== RUN ARRAY TO SET COLORS DEPENDING OF THE STATUS ====
            for (let ind = 0; ind < data?.length; ind++) {
                const elementData = data[ind];
                for (let i = 0; i < elementTagName.length; i++) {
                    const element = elementTagName[i];

                    for (let index = 0; index < elementData?.property_props?.length; index++) {
                        const model = elementData.property_props[index];
                        if (model.property_id === element.id) {
                            if (model.status === "ACTIVE") {
                                element.setAttribute("fill", "#00E503");
                                element.setAttribute("fill-opacity", 0.3);
                            } else if (model.status === "APART") {
                                element.setAttribute("fill", "#FFF300");
                                element.setAttribute("fill-opacity", 0.4);
                            } else {
                                element.setAttribute("fill", "#D80000");
                                element.setAttribute("fill-opacity", 0.3);
                            }
                            break;
                        }
                    }
                }
            }
        }
    };

    return (
        <Box
            pr={10}
            width="794px"
            minH="1260px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            backgroundImage="url('https://media.grupoguia.mx/assets/templates/availability-print-background.png')"
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="center"
            fontFamily="Montserrat"
            fontWeight="500"
            css={{
                "@media print": {
                    width: "21.59cm",
                    height: "27.94cm",
                    ["& backgroundSize"]: "cover",
                    margin: "0 0",
                },
            }}
        >
            {/* Encabezado */}
            <Stack position="absolute" top="85px" left="50px">
                <Text fontSize="14px" fontWeight="bold">
                    Disponibilidad ilustrada
                </Text>
                <Flex gap={10}>
                    <Text fontSize="10px">
                        <strong>Nombre de la torre:</strong>{" "}
                        {/* viewSelected?.outter_dimension_props[0]?.item_name?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) || */
                        /*dataDevelopment?.name?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())*/}
                        {decodeURIComponent(tower).replace(/\b\w/g, (char) => char.toUpperCase()) ||
                            dataDevelopment?.name
                                ?.toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                    </Text>
                    <Text fontSize="10px">
                        <strong>Vista a la que pertenece la imagen:</strong>{" "}
                        {decodeURIComponent(view).replace(/\b\w/g, (char) => char.toUpperCase())}
                    </Text>
                </Flex>
            </Stack>
            {/* Logo */}
            <Image
                src={dataDevelopment?.extra_props?.logo_developer || ""}
                position="absolute"
                top="85px"
                right="50px"
                height="60px"
                alt="simple icon"
            />
            {/* Contenedor del SVG */}
            <Box margin="auto">
                <SVG
                    style={{
                        margin: "auto",
                        width: "auto",
                        maxWidth: "630px",
                        height: "auto",
                        maxHeight: "700px",
                    }}
                    id="svg"
                    src={viewSelected?.map_image_url}
                    onLoad={loadSvg}
                />
            </Box>
            {/* Footer */}
            <Flex position="absolute" bottom="85px" left="50px" flexDirection="row" gap={8}>
                <Flex alignItems="center" marginRight="5px">
                    <Box backgroundColor="#B3C86C" width="24px" height="12px" borderRadius="2px" />
                    <Text fontSize="10px" marginLeft="3px">
                        Disponible
                    </Text>
                </Flex>
                <Flex alignItems="center" marginRight="5px">
                    <Box backgroundColor="#EF3E3F" width="24px" height="12px" borderRadius="2px" />
                    <Text fontSize="10px" marginLeft="3px">
                        Vendido o en proceso
                    </Text>
                </Flex>
                <Flex alignItems="center">
                    <Box backgroundColor="#FFCD00" width="24px" height="12px" borderRadius="2px" />
                    <Text fontSize="10px" marginLeft="3px">
                        Apartado
                    </Text>
                </Flex>
            </Flex>
            {/* Logos en el footer */}
            <Flex position="absolute" bottom="85px" right="40px" alignItems="center" gap={10}>
                <Box>
                    <Text fontWeight="bold" fontSize="6px" textAlign="center">
                        Una creación de
                    </Text>
                    <Image src={dataDevelopment?.extra_props?.logo_developer || ""} height="40px" />
                </Box>
                <Box>
                    <Text fontWeight="bold" fontSize="6px" textAlign="center" mb={3}>
                        Distribuido por
                    </Text>
                    <Image
                        src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/icons/guiasvg.svg"
                        width="100px"
                        alt="simple icon"
                    />
                </Box>
            </Flex>
        </Box>
    );
};

export default GeneratePdfSelection2D;
